module.exports = __webpack_public_path__ + "static/media/trueblue.eda6c35d.png";